import React        from 'react';
import { Redirect } from 'react-router-dom';
import Major        from './Major';
import MajorList    from './MajorList';

export const MajorConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path      : '/major/:view_type/:major_id',
            component : Major,
            permission: { component_name: 'major', permission_type: 'view_type' },
        },
        {
            path      : '/major/list',
            component : MajorList,
            permission: { component_name: 'major', permission_type: 'list' },
        },
        {
            path      : '/major/:view_type/',
            component : Major,
            permission: { component_name: 'major', permission_type: 'view_type' },
        },
        {
            path      : '/major',
            component : () => <Redirect to="/major/list" />,
            permission: { component_name: 'major', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/major/MajorConfig.js